import { Button } from "@salt-ds/core";
import React from "react";

type DefaultButtonProps = {
  label?: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "primary" | "secondary" | "cta";
  appearance?: "solid" | "bordered" | "transparent";
  sentiment?: "accented" | "neutral" | "positive" | "negative" | "caution";
  className?: string;
  children?: React.ReactNode;
};

const ButtonComponent = ({ ...props }: DefaultButtonProps) => {
  return (
    <>
      <Button
        onClick={props.onClick}
        variant={props.variant}
        className={props.className}
      >
        {props.children || props.label}
      </Button>
    </>
  );
};

export default ButtonComponent;
